// @flow
import { required } from 'redux-form-validators';
import { string, boolean } from '../../core/data/rules';
import type { MetaModel } from '../../core/data/rules';

export type OfflineToken = {|
  id: string,
  token: string,
  officeId: string,
  office: ?{ id: string, title: string },
  isActive: boolean,
  revokedAt: ?string,
  expiresAt: ?string,
  deviceInfo: ?string,
  boundDeviceId: ?string,
  createdAt: string,
|}

export const offlineTokenMetaModel: MetaModel = {
  name: 'OfflineToken',
  rules: {
    officeId: [string(), required()],
    deviceInfo: [string()],
  },
  labels: {
    officeId: 'Офис',
    deviceInfo: 'Информация об устройстве',
  },
};
